/**
 * Heritage Gold Palette
 * Elegant, timeless, cultural heritage
 */

import { ThemeColors } from '../../assets/theme';

export const heritageLight: ThemeColors = {
  // Primary palette - Rich gold with deep navy
  primary: '#C9A961',
  primaryLight: '#D4B877',
  primaryDark: '#B8941F',

  // Secondary palette - Amber and bronze
  secondary: '#E6A800',
  secondaryLight: '#F0B820',
  secondaryDark: '#CC9600',

  // Accent colors - Terracotta for warmth
  accent: '#C85A39',
  accentLight: '#D97352',
  accentDark: '#B04120',

  // Neutral palette - Warm beiges and creams
  background: '#FAF8F3',
  surface: '#FFFFFF',
  surfaceHover: '#F5F2EB',

  // Text colors
  text: '#2C2416',
  textSecondary: '#6B5D47',
  textMuted: '#9B8E7A',

  // Status colors
  success: '#28A745',
  warning: '#FFC107',
  error: '#DC3545',
  info: '#17A2B8',

  // Border and divider
  border: '#E8E0D4',
  borderLight: '#F1EBE0',
  divider: '#D4C9B8',

  // Shadows - Gold-tinted
  shadow: 'rgba(201, 169, 97, 0.1)',
  shadowHover: 'rgba(201, 169, 97, 0.15)',
  shadowDark: 'rgba(201, 169, 97, 0.2)',

  // Overlays
  overlay: 'rgba(27, 54, 93, 0.6)',
  overlayLight: 'rgba(201, 169, 97, 0.1)',

  // Gradients
  gradientPrimary: 'linear-gradient(135deg, #C9A961 0%, #E6A800 100%)',
  gradientSecondary: 'linear-gradient(135deg, #E6A800 0%, #C85A39 100%)',
  gradientBackground: 'linear-gradient(135deg, #FAF8F3 0%, #F5F2EB 100%)',

  // Glass morphism
  glass: 'rgba(255, 255, 255, 0.3)',
  glassBorder: 'rgba(201, 169, 97, 0.2)',
  glassShadow: '0 8px 32px 0 rgba(201, 169, 97, 0.4)',

  // ICOM specific (adapted)
  icomBlue: '#1B365D',
  icomGold: '#C9A961',
  icomNavy: '#1B365D',
  icomLightBlue: '#F5E6D3',
  icomWarmGray: '#F5F2EB',
};

export const heritageDark: ThemeColors = {
  // Primary palette
  primary: '#D4B877',
  primaryLight: '#E0C895',
  primaryDark: '#C9A961',

  // Secondary palette
  secondary: '#F0B820',
  secondaryLight: '#F5C84A',
  secondaryDark: '#E6A800',

  // Accent colors
  accent: '#D97352',
  accentLight: '#E68B6F',
  accentDark: '#C85A39',

  // Neutral palette - Dark with warm undertones
  background: '#1A1612',
  surface: '#25211C',
  surfaceHover: '#2F2A24',

  // Text colors
  text: '#E8E0D4',
  textSecondary: '#C4B8A8',
  textMuted: '#9B8E7A',

  // Status colors
  success: '#4CAF50',
  warning: '#FFB300',
  error: '#EF5350',
  info: '#29B6F6',

  // Border and divider
  border: '#3A342C',
  borderLight: '#2F2A24',
  divider: '#4A4238',

  // Shadows
  shadow: 'rgba(0, 0, 0, 0.4)',
  shadowHover: 'rgba(0, 0, 0, 0.5)',
  shadowDark: 'rgba(0, 0, 0, 0.6)',

  // Overlays
  overlay: 'rgba(0, 0, 0, 0.75)',
  overlayLight: 'rgba(0, 0, 0, 0.4)',

  // Gradients
  gradientPrimary: 'linear-gradient(135deg, #C9A961 0%, #E6A800 100%)',
  gradientSecondary: 'linear-gradient(135deg, #E6A800 0%, #C85A39 100%)',
  gradientBackground: 'linear-gradient(135deg, #1A1612 0%, #25211C 100%)',

  // Glass morphism
  glass: 'rgba(37, 33, 28, 0.8)',
  glassBorder: 'rgba(212, 184, 119, 0.2)',
  glassShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.6)',

  // ICOM specific
  icomBlue: '#1B365D',
  icomGold: '#D4B877',
  icomNavy: '#1B365D',
  icomLightBlue: '#3A342C',
  icomWarmGray: '#2F2A24',
};
